export default __webpack_public_path__ + "static/media/peter-darvill-evans-tardis.ef0c16db.jpg";